
export default class NoticeTable {
    latestNButton: HTMLButtonElement;
    displayAllButton: HTMLButtonElement;
    printButton: HTMLButtonElement;
    table: HTMLTableElement;
    allNotices: NodeListOf<HTMLTableRowElement>;
    itemsToShow = 5;

    constructor(elemId: string) {
        const widgetContainer = document.getElementById(elemId);
        this.table = widgetContainer.querySelector('table');
        this.allNotices = this.table.querySelectorAll('tbody tr');
        this.latestNButton = widgetContainer.querySelector('.latest-notices-button');
        this.displayAllButton = widgetContainer.querySelector('.display-all-button');
        this.printButton = widgetContainer.querySelector('.print-button');
        this.AttachEventListener();
        this.showLatestNNotices();
    }

    private AttachEventListener() {
        this.latestNButton.addEventListener('click', () => this.showLatestNNotices());
        this.displayAllButton.addEventListener('click', () => this.showAllNotices());
        this.printButton.addEventListener('click', () => this.printNoticeTable())
    }
    private showLatestNNotices() {
        this.allNotices.forEach((row, index) => {
            if (index > 4) {
                if (!row.classList.contains('hide'))
                    row.classList.add('hide');
            }
        })
    }
    private showAllNotices() {
        this.allNotices.forEach((row) => {
            if (row.classList.contains('hide'))
                row.classList.remove('hide');
        })
    }
    private printNoticeTable() {
        const clonedTable = this.table.cloneNode(true) as HTMLTableElement;

        const clonedRows = clonedTable.querySelectorAll('tbody tr');
        clonedRows.forEach(row => {
            if (row.classList.contains('hide')) {
                row.remove();
            }
        });

        const newWin = window.open("");
        newWin.document.write(clonedTable.outerHTML);
        newWin.print();
        newWin.close();
    }
}